import { fromJS, Map, List } from 'immutable';
import { TravellerRecord } from './../../Record/Orders';
const NAME_SPACE = 'TRAVELLER/';
const initialData = Map({
  pageSize: 10,
  currentPage: 1,
  count: 0,
  data: List([new TravellerRecord()]),
  loading: false,
});
const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialData;
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', (loading) => action.payload.state);
    case NAME_SPACE + 'RECEIVE_TRAVELLER_COLLECTION':
      return fromJS(action.payload);
    default:
      return state;
  }
};
const Traveller = (state = initialData, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'V_LOADING':
    case NAME_SPACE + 'RES_UPDATE':
    case NAME_SPACE + 'RECEIVE_TRAVELLER_COLLECTION':
      return item(state, action);
    default:
      return state;
  }
};
export default Traveller;
